import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const styles = {};

export const overrides = {
	'.neighborhoodsMap.citiesMap': {
		'.neighborhoodsMap__interactive': {
			aspectRatio: '2389.52 / 1504.15',
		},
		'.neighborhoodsMap__card': {
			minHeight: remCalc(260),
		},
		'.neighborhoodsMap__cardContent': {
			padding: remCalc(40),
		},
		[theme.breakpoints.down('sm')]: {
			'.neighborhoodsMap__cardContent': {
				padding: remCalc(32),
			},
		},
	},
};

export default styles;